
export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Panel - Story */}
          <div className="space-y-6 md:space-y-8">
            <div className="space-y-4 md:space-y-6">
              <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase">
                About Tadashi Consulting
              </p>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
                We don&apos;t just design spaces.
                <br />
                <span className="font-light">We build them.</span>
              </h2>
            </div>
            <div className="space-y-4 md:space-y-6 text-base lg:text-lg text-gray-600 leading-relaxed max-w-xl">
              <p>
                <strong>Tadashi Consulting</strong> is a full-service renovation and
                construction partner specializing in{' '}
                <strong>luxury residential and commercial transformations</strong> in
                Johannesburg. We combine expert construction with refined design to
                deliver spaces that exceed expectations.
              </p>
              <p>
                Our team of licensed contractors and skilled craftsmen bring decades of
                experience to every project. From structural alterations to high-end
                fit‑outs, we handle every detail with precision and care.
              </p>
              <p>
                We believe in full accountability, transparent communication, and
                delivering on time. Your vision becomes our mission, and we don&apos;t
                rest until it&apos;s built to perfection.
              </p>
            </div>
            <div className="pt-4 md:pt-6">
              <div className="w-20 h-0.5 bg-[#D4AF37] mb-4"></div>
              <p className="text-base lg:text-lg font-serif italic text-gray-700">
                Tadashi Yamamoto, Founder
              </p>
            </div>
          </div>

          {/* Right Panel - Visual Proof */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[400px] sm:h-[500px] lg:h-auto">
                <img
                  src="https://public.readdy.ai/ai/img_res/522b18609384b0cf50681025531b5c0d.jpg"
                  alt="Construction Craftsmanship Johannesburg"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute bottom-4 left-4 sm:bottom-8 sm:left-8 bg-white rounded-2xl shadow-2xl p-4 sm:p-6 lg:p-8 space-y-4 lg:space-y-6">
              <div className="space-y-1 sm:space-y-2">
                <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#D4AF37]">
                  98%
                </p>
                <p className="text-xs sm:text-sm text-gray-600">Client Satisfaction</p>
              </div>
              <div className="space-y-1 sm:space-y-2">
                <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#D4AF37]">
                  100%
                </p>
                <p className="text-xs sm:text-sm text-gray-600">On-Time Delivery</p>
              </div>
              <div className="space-y-1 sm:space-y-2">
                <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#D4AF37]">
                  Full
                </p>
                <p className="text-xs sm:text-sm text-gray-600">Accountability</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
